import {handleActions} from 'redux-actions'
import * as ActionTypes from './actionTypes'
import {UNLOCK_ALL_STATUS} from './constants'

export default function createReducer({LOCKOUT_POLICY}) {
    const initialState = {
        useLockoutPolicy: true,
        duration: 30,
        threshold: 6,
        counter: 1,
        unlockAllStatus: UNLOCK_ALL_STATUS.INITIAL,
        isModified: false,
    }

    if (!!LOCKOUT_POLICY) {
        initialState.useLockoutPolicy = LOCKOUT_POLICY.enabled
        initialState.duration = LOCKOUT_POLICY.durationMinutes
        initialState.threshold = LOCKOUT_POLICY.threshold
        initialState.counter = LOCKOUT_POLICY.resetCounterAfter
    }

    return handleActions({
        [ActionTypes.USE_LOCKOUT_POLICY_SET]: (state, {payload: useLockoutPolicy}) => ({
            ...state,
            useLockoutPolicy: useLockoutPolicy,
            isModified: true,
        }),
        [ActionTypes.LOCKOUT_DURATION_SET]: (state, {payload: duration}) => ({
            ...state,
            duration: duration,
            isModified: true,
        }),
        [ActionTypes.LOCKOUT_THRESHOLD_SET]: (state, {payload: threshold}) => ({
            ...state,
            threshold: threshold,
            isModified: true,
        }),
        [ActionTypes.LOCKOUT_COUNTER_SET]: (state, {payload: counter}) => ({
            ...state,
            counter: counter,
            isModified: true,
        }),
        [ActionTypes.LOCKOUT_UNLOCK_ALL_STATUS_SET]: (state, {payload: status}) => ({
            ...state,
            unlockAllStatus: status,
        })
    }, initialState)
}



// WEBPACK FOOTER //
// ./web/js/administration/lockoutPolicy/reducer.js